/*
  Expandura – Wächter gegen hängende Scroll-Sperren (Klaviyo)

  Gemessen am 27.08.2026 auf der Live-Seite:
  Klaviyo setzt beim Öffnen eines Popups die Klasse
  "klaviyo-prevent-body-scrolling" auf <body> (CSS: overflow:hidden).
  Die Klasse bleibt danach hängen – auch nach dem Schließen des Popups und
  sogar dann, wenn gar kein Popup mehr sichtbar ist. Ergebnis: Die Seite ist
  dauerhaft eingefroren (Seitenhöhe 13.377 px, scrollTop bleibt 0), Kunden
  erreichen den Kaufen-Button nie und melden "Warenkorb funktioniert nicht".

  Zwei Rettungen:
  1) Sperre gesetzt, aber KEIN Klaviyo-Overlay auf dem Bildschirm
     → sofort entsperren. Risikofrei, denn es gibt nichts zu bedienen.
  2) Overlay liegt oben UND der Kunde versucht mehrfach vergeblich zu scrollen
     → entsperren und das blockierende Overlay ausblenden. Greift nur, wenn
     jemand nachweislich festhängt; wer das Popup in Ruhe liest, scrollt nicht.

  Die theme-eigene Sperre (.overflow-hidden für Warenkorb + Modals) wird
  bewusst NICHT angefasst.
*/
(function () {
  if (window.__exScrollGuard) return;
  window.__exScrollGuard = true;

  var LOCK_CLASS = 'klaviyo-prevent-body-scrolling';
  var SCROLL_VERSUCHE_BIS_RETTUNG = 3;
  var scrollVersuche = 0;

  function istKlaviyoKnoten(node) {
    while (node && node !== document.body && node !== document.documentElement) {
      var c = (node.className || '').toString();
      if (/klaviyo|kl-private|kl-teaser/.test(c)) return node;
      node = node.parentElement;
    }
    return null;
  }

  // Hit-Test statt CSS-Raten: Was liegt wirklich oben auf dem Bildschirm?
  function overlayAufDemBildschirm() {
    var h = window.innerHeight, w = window.innerWidth;
    var punkte = [0.25, 0.5, 0.75];
    for (var i = 0; i < punkte.length; i++) {
      var el = document.elementFromPoint(w / 2, h * punkte[i]);
      var treffer = istKlaviyoKnoten(el);
      if (treffer) return treffer;
    }
    return null;
  }

  function entsperren() {
    var b = document.body;
    if (!b) return;
    b.classList.remove(LOCK_CLASS);
    var s = b.style;
    if (s.overflow === 'hidden') s.overflow = '';
    if (s.position === 'fixed') {
      s.position = '';
      s.top = '';
      s.width = '';
    }
  }

  function gesperrt() {
    return document.body && document.body.classList.contains(LOCK_CLASS);
  }

  function pruefen() {
    if (!gesperrt()) {
      scrollVersuche = 0;
      return;
    }
    var overlay = overlayAufDemBildschirm();
    if (!overlay) {
      // Fall 1: Sperre ohne Grund → weg damit.
      entsperren();
      scrollVersuche = 0;
      return;
    }
    // Fall 2: Kunde hängt fest und versucht vergeblich zu scrollen.
    if (scrollVersuche >= SCROLL_VERSUCHE_BIS_RETTUNG) {
      var box = overlay.getBoundingClientRect();
      var deckendGross =
        box.width >= window.innerWidth * 0.9 && box.height >= window.innerHeight * 0.5;
      if (deckendGross) overlay.style.setProperty('display', 'none', 'important');
      entsperren();
      scrollVersuche = 0;
    }
  }

  function scrollVersuchGezaehlt() {
    if (gesperrt()) {
      scrollVersuche++;
      pruefen();
    }
  }

  function start() {
    pruefen();
    try {
      new MutationObserver(pruefen).observe(document.body, {
        attributes: true,
        attributeFilter: ['class', 'style'],
        childList: true,
        subtree: true
      });
    } catch (e) {}
    window.addEventListener('wheel', scrollVersuchGezaehlt, { passive: true });
    window.addEventListener('touchmove', scrollVersuchGezaehlt, { passive: true });
    setInterval(pruefen, 700);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* Expandura 02.10.2026: Geht das Klaviyo-Pop-up bei offenem Warenkorb auf, bleibt nach dem Schließen eine
   unsichtbare, bildschirmfüllende Klaviyo-Schicht liegen (Deckkraft 0, z-index 90000). Sie fängt jeden Tipp ab,
   „Jetzt sicher zur Kasse“ reagiert nicht mehr. Dieser Block räumt die Schicht weg, sobald sie nach dem Schließen
   unsichtbar hängen bleibt, und leitet einen Tipp, der sie trotzdem trifft, an den Knopf darunter weiter. */
(function(){
  if (window.__exKlaviyoReste) return; window.__exKlaviyoReste = true;
  var LOCK = 'klaviyo-prevent-body-scrolling';
  var zustand = new WeakMap();
  var entferntUm = 0;
  function schichten(){ return document.querySelectorAll('div.needsclick[class*="kl-private-reset-css"]'); }
  function vollflaechig(el){ var r = el.getBoundingClientRect(); return r.width >= window.innerWidth * 0.9 && r.height >= window.innerHeight * 0.5; }
  function deckkraft(el){ var cs = getComputedStyle(el); if (cs.display === 'none' || cs.visibility === 'hidden') return -1; return parseFloat(cs.opacity); }
  function entsperren(){
    var b = document.body; if (!b) return;
    b.classList.remove(LOCK);
    var s = b.style; if (s.overflow === 'hidden') s.overflow = '';
    if (s.position === 'fixed') { s.position = ''; s.top = ''; s.width = ''; }
  }
  function wegraeumen(el){
    el.style.setProperty('display', 'none', 'important');
    entferntUm = Date.now();
    zustand.set(el, { sichtbar: false, seit: 0 });
    /* Andere Klaviyo-Formulare offen? Dann die Sperre lassen. */
    var offen = false, liste = schichten();
    for (var i = 0; i < liste.length; i++) { if (liste[i] !== el && deckkraft(liste[i]) > 0.5 && vollflaechig(liste[i])) offen = true; }
    if (!offen) entsperren();
  }
  function haengend(el){
    if (!el || getComputedStyle(el).position !== 'fixed' || !vollflaechig(el)) return false;
    var z = zustand.get(el); var op = deckkraft(el);
    return !!(z && z.sichtbar && op >= 0 && op < 0.05);
  }
  function pruefen(){
    var jetzt = Date.now(), liste = schichten();
    for (var i = 0; i < liste.length; i++) {
      var el = liste[i];
      if (getComputedStyle(el).position !== 'fixed') continue;
      var op = deckkraft(el); if (op < 0) continue;
      if (!vollflaechig(el)) continue;
      var z = zustand.get(el) || { sichtbar: false, seit: 0 };
      if (op > 0.5) { z.sichtbar = true; z.seit = 0; }
      else if (op < 0.05 && z.sichtbar) {
        if (!z.seit) z.seit = jetzt;
        else if (jetzt - z.seit >= 400) { wegraeumen(el); continue; }
      }
      zustand.set(el, z);
    }
  }
  function schichtVon(node){
    while (node && node !== document.body && node !== document.documentElement) {
      if (node.nodeType === 1 && /kl-private-reset-css/.test(node.className || '') && /needsclick/.test(node.className || '') && getComputedStyle(node).position === 'fixed') return node;
      node = node.parentElement;
    }
    return null;
  }
  /* Tipp auf die unsichtbare Schicht: sofort wegräumen, damit der Tipp beim Knopf darunter ankommt */
  function beimDruecken(e){
    var s = schichtVon(e.target);
    if (s && haengend(s)) wegraeumen(s);
  }
  document.addEventListener('pointerdown', beimDruecken, true);
  document.addEventListener('touchstart', beimDruecken, { capture: true, passive: true });
  /* Kam der Klick trotzdem nicht beim Knopf an (Maus: Klickziel = gemeinsamer Vorfahr), einmal weiterleiten */
  document.addEventListener('click', function(e){
    if (!entferntUm || Date.now() - entferntUm > 1500 || typeof e.clientX !== 'number') return;
    var unten = document.elementFromPoint(e.clientX, e.clientY);
    if (!unten) return;
    var ziel = unten.closest ? unten.closest('button, a[href], input[type="submit"], label, summary, [role="button"]') : null;
    if (!ziel || ziel === e.target || ziel.contains(e.target)) return;
    var t = e.target;
    if (t !== document.body && t !== document.documentElement && !schichtVon(t)) return;
    e.preventDefault(); e.stopPropagation();
    entferntUm = 0;
    ziel.click();
  }, true);
  function start(){
    pruefen();
    setInterval(pruefen, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
